import { Dispatch, SetStateAction } from "react"
import { Block, useStyletron } from "@mezo-org/mezo-clay"

import TermsOfUseCheckbox from "#/shared/components/TermsOfUseCheckbox"
import { MatsnetActionButton } from "#/ui/Button"

type BorrowTermsProps = {
  onSubmit: () => void
  label: string
  dataAttr?: string
  setHasAcceptedTerms: Dispatch<SetStateAction<boolean>>
  hasAcceptedTerms: boolean
}

export default function BorrowTerms({
  hasAcceptedTerms,
  setHasAcceptedTerms,
  onSubmit,
  label,
  dataAttr,
}: BorrowTermsProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: theme.sizing.scale800,
        position: "absolute",
        width: "100%",
        padding: theme.sizing.scale800,
        borderRadius: theme.borders.radius500,
        bottom: 0,
        left: 0,
        background: theme.colors.backgroundPrimary,
        boxShadow: "0 -8px 36px 0px rgba(0,0,0,0.17)",
      })}
    >
      <TermsOfUseCheckbox
        checked={hasAcceptedTerms}
        onChange={(ev) => setHasAcceptedTerms(ev.target.checked)}
      />

      <MatsnetActionButton
        size="large"
        onClick={onSubmit}
        isDisabled={!hasAcceptedTerms}
        dataAttr={dataAttr}
      >
        {label}
      </MatsnetActionButton>
    </Block>
  )
}
